<template>
  <div>
    <div class="bg-content padding15">
      <el-form size="small" label-width="140px" label-position="left">
        <el-row :gutter="24">
          <el-form-item label="姓名">
            <el-col :span="9">
              <el-input v-model="infoReq.name" placeholder="请输入姓名"/>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row :gutter="24">
          <el-form-item label="邮箱">
            <el-col :span="9">
              <el-input v-model="infoReq.email" placeholder="请输入邮箱"/>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row :gutter="24">
          <el-form-item label="手机号">
            <el-col :span="9">
              <el-input v-model="infoReq.phone" placeholder="请输入手机号"/>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row :gutter="24">
          <el-form-item label="角色">
            <el-col :span="9">
              {{this.infoReq.roleName}}
            </el-col>
          </el-form-item>
        </el-row>
        <el-row :gutter="24">
          <el-form-item label="上次登录时间">
            <el-col :span="9">
              {{this.infoReq.beforeLoginTime}}
            </el-col>
          </el-form-item>
        </el-row>
        <el-row :gutter="24">
          <el-form-item label="上次登录IP">
            <el-col :span="9">
              {{this.infoReq.beforeLoginIp}}
            </el-col>
          </el-form-item>
        </el-row>
        <el-row :gutter="24">
          <el-form-item label="近期登陆设备MAC">
            <el-col :span="9">
              {{this.infoReq.mac}}
            </el-col>
          </el-form-item>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="9">
            <el-button type="primary" size="small" style="margin-left: 40%;" @click="update">保存</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      infoReq: {
        name: null,
        email: null,
        phone: null,
        beforeLoginTime: null,
        beforeLoginIp: null,
        mac: null,
        roleName: null
      }
    };
  },
  methods: {
    userInfo() {
      this.$ajax({
        url: '/account/current'
      }).then((res) => {
        if (res.data.account) {
          this.infoReq = res.data.account;
        }
      });
    },
    update() {
      this.$confirm('您确定要保存吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          url: '/account/update',
          method: 'POST',
          data: this.infoReq
        });
      });
    }
  },
  mounted() {
    this.userInfo();
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/userCenter/info.vue